"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsMemberCertifiedRequest = void 0;
var IsMemberCertifiedRequest = /** @class */ (function () {
    function IsMemberCertifiedRequest() {
    }
    return IsMemberCertifiedRequest;
}());
exports.IsMemberCertifiedRequest = IsMemberCertifiedRequest;
;
//# sourceMappingURL=isMemberCertified.request.js.map